let wishlistPopupTimeout
let lastFocusedElement
let isPopupVisible = false
let usingKeyboard = false

window.showWishlistPopup = function (messageHtml) {
  const popup = document.getElementById('wishlist-popup')
  if (!popup) return

  lastFocusedElement = document.activeElement

  popup.innerHTML = messageHtml
  popup.hidden = false
  popup.classList.add('show')
  isPopupVisible = true

  // focus first focusable child or the popup itself
  setTimeout(() => {
    const focusTarget =
      popup.querySelector('a, button, [tabindex]:not([tabindex="-1"])') ||
      popup
    focusTarget.focus()
  }, 50)

  clearTimeout(wishlistPopupTimeout)

  wishlistPopupTimeout = setTimeout(() => {
    popup.classList.remove('show')
    popup.hidden = true
    isPopupVisible = false

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus()
    }
  }, 3000)
}

/* freeze Tab while popup is visible */
document.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    usingKeyboard = true
    if (isPopupVisible) e.preventDefault() // trap focus
  }
})

/* reset keyboard mode on mouse interaction */
document.addEventListener('mousedown', () => {
  usingKeyboard = false
})

/* Globo checkbox fix */
document.addEventListener('keydown', (e) => {
  if (e.key === ' ' || e.code === 'Space') {
    const el = document.activeElement;

    if (
      el.tagName === 'LABEL' &&
      el.classList.contains('globo-option') && // optional: limit to globo label
      el.closest('.globo-form') && // make sure it's inside .globo-form
      el.hasAttribute('for')
    ) {
      const targetId = el.getAttribute('for');
      const checkbox = document.getElementById(targetId);

      if (
        checkbox &&
        checkbox.type === 'checkbox' &&
        checkbox.closest('.globo-form')
      ) {
        e.preventDefault();
        checkbox.click();
      }
    }
  }
});



function patchLvOptionSlideKeyboardSupport() {
  document.querySelectorAll('lv-option-slide').forEach((slideEl) => {
    const slideContent = slideEl.querySelector('.lv-option-slide-items');
    if (!slideContent) return;

    slideContent.addEventListener('focusin', (event) => {
      const focusedEl = event.target;
      if (!(focusedEl instanceof HTMLElement)) return;
      if (!slideContent.contains(focusedEl)) return;

      const containerRect = slideEl.getBoundingClientRect();
      const focusedRect = focusedEl.getBoundingClientRect();
      const currentOffset = parseFloat(slideContent.dataset._patchedOffset || '0');
      const maxOffset = Math.max(0, slideContent.scrollWidth - slideEl.clientWidth);

      let newOffset = currentOffset;

      const focusedLeft = focusedRect.left;
      const focusedRight = focusedRect.right;
      const containerLeft = containerRect.left;
      const containerRight = containerRect.right;

      if (focusedLeft < containerLeft) {
        const delta = containerLeft - focusedLeft + 16;
        newOffset = Math.max(0, currentOffset - delta);
      } else if (focusedRight > containerRight) {
        const delta = focusedRight - containerRight + 16;
        newOffset = Math.min(maxOffset, currentOffset + delta);
      } else {
        return;
      }

      slideContent.style.transform = `translateX(-${newOffset}px)`;
      slideContent.dataset._patchedOffset = newOffset;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', patchLvOptionSlideKeyboardSupport);
} else {
  patchLvOptionSlideKeyboardSupport();
}
